import React from 'react'

const AnotherPage = () => {
    return (
      <div>    
        <h1>Another Page</h1>
      </div>
    )
}

export default AnotherPage



// WEBPACK FOOTER //
// ./src/pages/AnotherPage/SectionAnotherPage.js